"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLANNED_REPRODUCTIONS_PER_OPERATING_HOUR = void 0;
exports.getWeeklyMinimumImpacts = getWeeklyMinimumImpacts;
const DAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
const SECONDS_PER_DAY = 86_400;
exports.PLANNED_REPRODUCTIONS_PER_OPERATING_HOUR = 40;
function getWeeklyMinimumImpacts(schedule) {
    if (!schedule || DAYS.every((day) => schedule[day] === undefined)) {
        return 7 * 24 * exports.PLANNED_REPRODUCTIONS_PER_OPERATING_HOUR;
    }
    const operatingSeconds = DAYS.reduce((weekTotal, day) => {
        const daySchedule = schedule[day];
        if (!daySchedule?.isOperative) {
            return weekTotal;
        }
        if (!daySchedule.timetable?.length) {
            return weekTotal + SECONDS_PER_DAY;
        }
        const intervals = daySchedule.timetable
            .filter((slot) => Number.isFinite(slot.from) && Number.isFinite(slot.to))
            .map((slot) => ({
            from: Math.max(0, Math.min(SECONDS_PER_DAY, slot.from)),
            to: Math.max(0, Math.min(SECONDS_PER_DAY, slot.to)),
        }))
            .filter((slot) => slot.to > slot.from)
            .sort((first, second) => first.from - second.from);
        let dayTotal = 0;
        let currentFrom;
        let currentTo;
        for (const interval of intervals) {
            if (currentFrom === undefined || currentTo === undefined) {
                currentFrom = interval.from;
                currentTo = interval.to;
                continue;
            }
            if (interval.from <= currentTo) {
                currentTo = Math.max(currentTo, interval.to);
                continue;
            }
            dayTotal += currentTo - currentFrom;
            currentFrom = interval.from;
            currentTo = interval.to;
        }
        if (currentFrom !== undefined && currentTo !== undefined) {
            dayTotal += currentTo - currentFrom;
        }
        return weekTotal + dayTotal;
    }, 0);
    return (operatingSeconds / 3600) * exports.PLANNED_REPRODUCTIONS_PER_OPERATING_HOUR;
}
